import { getPaddingFromProps} from './paddingHelper'

export {
  getPaddingFromProps
}
